import { observer } from 'mobx-react-lite';
import { UnitQueueRowData } from '../../../socket/stream-types';
import { StatusColorCell } from './status-color-cell';

export const CallSignColorCodedCell = observer(function CallSignColorCodedCell({
    data,
}: {
    data: UnitQueueRowData;
}): React.ReactElement {
    return (
        <StatusColorCell
            value={data.callSign}
            tip={data.personnelFullName}
            contentAlignment="CENTER"
            data={data}
        />
    );
});
